import { BUDGET_MANAGEMENT_ACTIONS } from './budgetManagement.types'

export const setBudgetManagementStatusAction = payload => ({
  type: BUDGET_MANAGEMENT_ACTIONS.SET_BUDGET_MANAGEMENT_STATUS,
  payload
})

export const setBudgetManagementErrorsAction = payload => ({
  type: BUDGET_MANAGEMENT_ACTIONS.SET_BUDGET_MANAGEMENT_ERRORS,
  payload
})

export const setBudgetManagementDataAction = payload => ({
  type: BUDGET_MANAGEMENT_ACTIONS.SET_BUDGET_MANAGEMENT_DATA,
  payload
})

export const clearBudgetManagementAction = () => ({
  type: BUDGET_MANAGEMENT_ACTIONS.CLEAR_BUDGET_MANAGEMENT
})
